import React, { useEffect, useState } from "react";
import { Check } from "lucide-react";
import { maintenanceApi, ZitadelUnlinkedOrg } from "../../../api/maintenance";
import { errText } from "./zitadelShared";
import { useNotice } from "../shared/useNotice";

/**
 * Flow 3 — both org_custom and the Zitadel org already exist:
 * just write zitadel_tenant_id onto the org_custom row.
 */

const ZitadelFlowLinkOnly: React.FC = () => {
  const [orgs, setOrgs] = useState<ZitadelUnlinkedOrg[]>([]);
  const [ocName, setOcName] = useState("");
  const [zid, setZid] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useNotice("error", "");
  const [linkedTo, setLinkedTo] = useState("");

  useEffect(() => {
    maintenanceApi
      .zitadelUnlinkedOrgs()
      .then((r) => setOrgs(r.data))
      .catch((e) => setError(errText(e, "Failed to load org_custom rows")));
  }, []);

  const doLink = async () => {
    if (!ocName) return setError("Pick an org_custom row");
    if (!zid.trim()) return setError("Enter the existing Zitadel org id");
    setBusy(true);
    setError("");
    try {
      const r = await maintenanceApi.zitadelLinkTenant({
        org_name: ocName,
        zitadel_org_id: zid.trim(),
      });
      setLinkedTo(r.data.zitadel_tenant_id);
    } catch (e) {
      setError(errText(e, "Failed to link tenant"));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="ztl-card">
      {error && <p className="maint-form-error">{error}</p>}
      {linkedTo ? (
        <>
          <p className="ztl-summary" style={{ color: "#2e7d32" }}>
            <Check size={14} /> Linked — {ocName}.zitadel_tenant_id ={" "}
            <code>{linkedTo}</code>
          </p>
          <div className="maint-form-actions" style={{ marginTop: 12 }}>
            <button
              className="maint-btn-secondary"
              onClick={() => window.location.reload()}
            >
              Link another
            </button>
          </div>
        </>
      ) : (
        <>
          <h3 style={{ marginTop: 0 }}>Link existing org_custom ↔ Zitadel</h3>
          <label className="ztl-field">
            <span>org_custom (unlinked) *</span>
            <select value={ocName} onChange={(e) => setOcName(e.target.value)}>
              <option value="">Select org_custom...</option>
              {orgs.map((o) => (
                <option key={o.org_custom_id} value={o.name}>
                  {o.name}
                </option>
              ))}
            </select>
          </label>
          <label className="ztl-field">
            <span>Existing Zitadel org id *</span>
            <input
              value={zid}
              onChange={(e) => setZid(e.target.value)}
              placeholder="e.g. 373450158823703879"
            />
          </label>
          <div className="maint-form-actions">
            <button
              className="maint-btn-primary"
              disabled={busy}
              onClick={doLink}
            >
              {busy ? "Linking..." : "Link Tenant"}
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default ZitadelFlowLinkOnly;
